/** Sales targets, performance, manager dashboards, and course routing UI copy. */
export const targetsArabicTranslations: Record<string, string> = {
  "Target Planning": "تخطيط التارجت",
  "Collections": "التحصيلات",
  "Historical Monthly Activity": "نشاط الشهر التاريخي",
  "Follow-ups": "المتابعات",
  "Course Assignment & Lead Routing": "تعيين الكورسات وتوزيع العملاء",
  "Assign specific courses to salespeople and control who receives new leads based on course interest and staff availability.": "عيّن كورسات محددة لمندوبي المبيعات، وحدد مين يستقبل العملاء الجدد حسب الكورس اللي مهتمين بيه وتوفر الموظف.",
  "Course assignment and lead routing": "تعيين الكورسات وتوزيع العملاء",
  "Assign specific courses to each salesperson and control lead routing by course interest and staff availability.": "عيّن كورسات محددة لكل مندوب مبيعات، وحدد استقبال العملاء حسب الكورس اللي مهتمين بيه وتوفر الموظف.",
  "Disabled - Left Company": "متوقف - ساب الشركة",
  "Paused - Vacation": "متوقف مؤقتًا - في إجازة",
  "Receiving Leads": "بيستقبل عملاء",
  "No Leads Assigned": "مفيش عملاء متوزعين عليه",
  "Left Company": "ساب الشركة",
  "On Vacation": "في إجازة",
  "Saved course assignments for {0}": "تم حفظ تعيينات الكورسات لـ {0}",
  "Failed to save assignments": "تعذر حفظ التعيينات",
  "Network error saving assignments": "حصل خطأ في الاتصال أثناء حفظ التعيينات",
  "{0} status updated": "تم تحديث حالة {0}",
  "Failed to update status": "تعذر تحديث الحالة",
  "Network error updating status": "حصل خطأ في الاتصال أثناء تحديث الحالة",
  "Mark as Left Company?": "تأكيد إنه ساب الشركة؟",
  "Failed to load details": "تعذر تحميل التفاصيل",
  "Network error loading details": "حصل خطأ في الاتصال أثناء تحميل التفاصيل",
  "View History": "عرض السجل",
  "Assignment Log": "سجل تعيين الكورسات",
  "Set Vacation": "تسجيل إجازة",
  "Mark as Left": "تسجيل مغادرة الشركة",
  "Return Active": "إرجاعه للعمل",
  "Reactivate": "إعادة تفعيل",
  "Edit courses for {0}": "تعديل كورسات {0}",
  "Edit Courses": "تعديل الكورسات",
  "Status & Routing": "الحالة وتوزيع العملاء",
  "Main Action": "الإجراء الأساسي",
  "More Actions for {0}": "إجراءات إضافية لـ {0}",
  "No active salesperson is available for course assignment.": "مفيش مندوب مبيعات نشط متاح لتعيين الكورسات.",
  "No Courses Assigned": "مفيش كورسات متعينة",
  "Course Assignment Audit Log": "سجل تغييرات تعيين الكورسات",
  "Who changed this salesperson's assigned courses, when, and what exactly changed?": "مين غيّر كورسات المندوب، وإمتى، وإيه اللي اتغير بالضبط؟",
  "Courses Updated": "تم تحديث الكورسات",
  "Changed by:": "التغيير بواسطة:",
  "Before": "قبل",
  "After": "بعد",
  "Removed": "اتشال",
  "Note:": "ملاحظة:",
  "No assignment log found": "مفيش سجل تعيينات",
  "Employee Routing History": "سجل حالة الموظف وتوزيع العملاء",
  "What happened to this salesperson over time?": "إيه اللي حصل للمندوب مع الوقت؟",
  "Performed by:": "الإجراء بواسطة:",
  "Related lead:": "العميل المرتبط:",
  "No notes found": "مفيش ملاحظات",
  "No history found": "مفيش سجل",
  "Verified employment dates": "تواريخ العمل المعتمدة",
  "Enter dates from an approved employment record. Do not estimate them from sales or activity.": "اكتب التواريخ من سجل عمل معتمد. متقدرهاش من المبيعات أو النشاط.",
  "Start Date": "تاريخ بداية العمل",
  "Verified Start Date": "تاريخ بداية العمل المعتمد",
  "Last Working Date": "آخر يوم عمل",
  "Verified Last Working Date": "آخر يوم عمل المعتمد",
  "AR": "AR",
  "Course assignment visibility controls": "خيارات عرض تعيينات الكورسات",
  "Active Sales": "مندوبي المبيعات النشطين",
  "Covered Courses": "الكورسات المغطاة",
  "No Leads": "مفيش عملاء",
  "Course assignment filters": "فلاتر تعيين الكورسات",
  "No sales employees found": "مفيش موظفين مبيعات",
  "Salesperson details": "تفاصيل المندوب",
  "Salesperson Details": "تفاصيل مندوب المبيعات",
  "Close panel": "قفل اللوحة",
  "No email": "مفيش إيميل",
  "Assigned Courses": "الكورسات المتعينة",
  "No internal notes recorded.": "مفيش ملاحظات داخلية مسجلة.",
  "Select a salesperson": "اختار مندوب مبيعات",
  "Save Assignment": "حفظ التعيين",
  "Employment Status": "حالة العمل",
  "Routing Status": "حالة توزيع العملاء",
  "Select one or more courses. This salesperson will only receive leads from the selected courses.": "اختار كورس أو أكتر. المندوب ده هيستقبل عملاء الكورسات المختارة بس.",
  "Selected courses: receives leads from selected courses only.": "الكورسات المختارة: بيستقبل عملاء الكورسات المختارة بس.",
  "No Courses Assigned: receives no leads.": "مفيش كورسات متعينة: مش بيستقبل عملاء.",
  "On Vacation: changes are saved, routing stays paused.": "في إجازة: التغييرات بتتحفظ، وتوزيع العملاء بيظل متوقف.",
  "Select Courses": "اختار الكورسات",
  "Search courses...": "ابحث عن كورس...",
  "No courses found": "مفيش كورسات",
  "Selected Courses (": "الكورسات المختارة (",
  "Clear All": "مسح الكل",
  "No selected courses": "مفيش كورسات مختارة",
  "Remove {0}": "إزالة {0}",
  "This salesperson will not receive any leads until at least one course is assigned.": "المندوب ده مش هيستقبل أي عملاء لحد ما يتعين له كورس واحد على الأقل.",
  "Campaign": "الحملة",
  "Activity": "النشاط",
  "Record": "السجل",
  "Add any notes...": "ضيف أي ملاحظات...",
  "Set follow-up": "حدد متابعة",
  "Campaign ID": "رقم الحملة",
  "Search courses": "ابحث عن كورسات",
  "All campaigns": "كل الحملات",
  "All employees": "كل الموظفين",
  "Loading Sales Manager dashboard": "جاري تحميل لوحة مدير المبيعات",
  "Contact due leads": "تواصل مع العملاء اللي جه ميعاد متابعتهم",
  "Follow-ups due today": "متابعات ميعادها النهارده",
  "Upcoming today, excluding overdue": "المتابعات الجاية النهارده، من غير المتأخرة",
  "New leads without contact": "عملاء جدد من غير تواصل",
  "Assign or make first contact": "وزع العميل أو ابدأ أول تواصل",
  "Receipts awaiting approval": "إيصالات مستنية الموافقة",
  "Review the approval status with the responsible team": "راجع حالة الموافقة مع الفريق المسؤول",
  "Registered, waiting for payment": "التسجيل مكتمل، ومستني الدفع",
  "Follow up before they go cold": "تابعهم قبل ما يفقدوا الاهتمام",
  "New leads": "عملاء جدد",
  "Assigned now": "متوزعين حاليًا",
  "Paid leads": "عملاء دفعهم معتمد",
  "Cash collected": "النقد المحصل",
  "Unnamed campaign": "حملة من غير اسم",
  "ID": "الرقم",
  "No campaign activity in this period.": "مفيش نشاط للحملات في الفترة دي.",
  "Sales Manager dashboard": "لوحة مدير المبيعات",
  "Sales analysis": "تحليل المبيعات",
  "Sales overview": "نظرة عامة على المبيعات",
  "All time": "كل الفترات",
  "Custom dates": "تواريخ مخصصة",
  "Filters": "الفلاتر",
  "Refresh dashboard": "تحديث اللوحة",
  "Export summary": "تصدير الملخص",
  "Dashboard scope": "نطاق اللوحة",
  "All accessible employees and leads": "كل الموظفين والعملاء المسموح لك تشوفهم",
  "Sales & cash: selected period · Lead queues & pipeline: current state": "المبيعات والتحصيل: الفترة المختارة · قوائم العملاء ومراحل البيع: الحالة الحالية",
  "Updated": "آخر تحديث",
  "Updating figures for this scope…": "جاري تحديث الأرقام للنطاق ده…",
  "Manager actions": "إجراءات المدير",
  "Distribution & rules": "التوزيع والقواعد",
  "Team & targets": "الفريق والأهداف",
  "Team performance": "أداء الفريق",
  "Pipeline snapshot": "ملخص مراحل البيع",
  "From": "من",
  "To": "إلى",
  "Branch": "الفرع",
  "Team": "الفريق",
  "All teams": "كل الفرق",
  "Employee": "الموظف",
  "The connected API has not confirmed this Campaign ID filter. Figures below are not campaign scoped yet.": "الـ API المتصل لسه ما أكدش تطبيق فلتر رقم الحملة. الأرقام اللي تحت لسه مش خاصة بالحملة.",
  "Back to overview": "رجوع للنظرة العامة",
  "Export contains the summary, campaign and team totals for this scope.": "التصدير فيه الملخص وإجماليات الحملات والفريق للنطاق ده.",
  "Analysis views": "عروض التحليل",
  "Campaign performance": "أداء الحملات",
  "Exact Meta campaign IDs · selected period": "أرقام حملات Meta الدقيقة · الفترة المختارة",
  "Campaign results are unavailable from the connected API.": "نتائج الحملات مش متاحة من الـ API المتصل.",
  "New leads are created in the selected period; assigned is their current owner count. Booked, paid and cash are events in that period, including older leads.": "العملاء الجدد اتسجلوا في الفترة المختارة؛ وعدد المتوزعين حسب المالك الحالي. الحجز والدفع والتحصيل أحداث حصلت في الفترة دي، وبتشمل عملاء أقدم.",
  "Leads by course": "العملاء حسب الكورس",
  "Current lead interests": "اهتمامات العملاء الحالية",
  "Current stages, independent of the period": "المراحل الحالية، بغض النظر عن الفترة",
  "employees": "موظفين",
  "Course sales": "مبيعات الكورسات",
  "Paid sales": "مبيعات بدفع معتمد",
  "Achieved": "المحقق",
  "{0} course sales": "{0} مبيعات كورسات",
  "{0} paid sales": "{0} مبيعات بدفع معتمد",
  "{0} overdue follow-ups": "{0} متابعات متأخرة",
  "{0} target": "هدف {0}",
  "{0} target achievement": "نسبة تحقيق هدف {0}",
  "No employees in this scope.": "مفيش موظفين في النطاق ده.",
  "Sales and paid sales are period results. Overdue follow-ups are current. Select a number to see its records.": "المبيعات والمبيعات بدفع معتمد نتائج للفترة. المتابعات المتأخرة حسب الوضع الحالي. اضغط على رقم لعرض سجلاته.",
  "Business result": "نتيجة الأعمال",
  "Approved course value": "قيمة الكورسات المعتمدة",
  "Eligible receipts": "الإيصالات المؤهلة",
  "API update needed": "مطلوب تحديث الـ API",
  "Bookings unavailable from API": "الحجوزات مش متاحة من الـ API",
  "Monthly target progress": "تقدم الهدف الشهري",
  "Target progress": "تقدم الهدف",
  "target": "الهدف",
  "Current state · all dates": "الحالة الحالية · كل التواريخ",
  "View leads": "عرض العملاء",
  "No urgent lead queues right now.": "مفيش قوائم عملاء محتاجة تدخل عاجل حاليًا.",
  "View analysis": "عرض التحليل",
  "Close details": "قفل التفاصيل",
  "The record total includes previous-period records when available. The headline figure uses the selected period only.": "إجمالي السجلات بيشمل سجلات الفترة السابقة لو متاحة. الرقم الرئيسي للفترة المختارة بس.",
  "No records in this scope.": "مفيش سجلات في النطاق ده.",
  "records. The summary export does not contain the full record list.": "سجلات. تصدير الملخص مش بيشمل قائمة السجلات كاملة.",
  "Loading business results": "جاري تحميل نتائج الأعمال",
  "Loading attention metrics": "جاري تحميل مؤشرات المتابعة",
  "Loading pipeline overview": "جاري تحميل نظرة عامة على مراحل البيع",
  "Loading sales team performance": "جاري تحميل أداء فريق المبيعات",
  "Loading manager attention": "جاري تحميل ما يحتاج انتباه المدير",
  "Overview Dashboard": "لوحة النظرة العامة",
  "Dashboard filters": "فلاتر اللوحة",
  "Custom": "مخصص",
  "All Teams": "كل الفرق",
  "More filters": "فلاتر إضافية",
  "Facebook Campaign ID": "رقم حملة فيسبوك",
  "All Facebook campaigns": "كل حملات فيسبوك",
  "Export Summary": "تصدير الملخص",
  "Date from": "من تاريخ",
  "Date to": "إلى تاريخ",
  "Campaign filter is waiting for the matching dashboard API.": "فلتر الحملة مستني الـ API المناسب للوحة.",
  "The current response does not confirm that these metrics are filtered by the selected campaign ID.": "الرد الحالي ما بيأكدش إن الأرقام دي متفلترة برقم الحملة المختار.",
  "Data needs review": "البيانات محتاجة مراجعة",
  "Employee not in selected period": "الموظف خارج الفترة المختارة",
  "No data for selected filters": "مفيش بيانات للفلاتر المختارة",
  "The selected scope has no matching records. This is not a performance rating.": "مفيش سجلات مطابقة للنطاق المختار. ده مش تقييم للأداء.",
  "No Target": "مفيش هدف",
  "No target is assigned to this selected scope.": "مفيش هدف متعين للنطاق المختار.",
  "No Commission Policy": "مفيش سياسة عمولة",
  "Earned commission is N/A until an applicable policy is defined.": "العمولة المستحقة غير متاحة لحد ما تتحدد سياسة مناسبة.",
  "Performance for Selected Period": "أداء الفترة المختارة",
  "Sales Today": "مبيعات النهارده",
  "Confirmed Sales (Total)": "المبيعات المؤكدة (الإجمالي)",
  "Full sales value · not collected cash": "قيمة المبيعات كاملة · مش النقد المحصل",
  "Cash Collected (Gross Eligible Receipts)": "النقد المحصل (إجمالي الإيصالات المؤهلة)",
  "Actual payments · refunds not netted": "دفعات فعلية · من غير خصم الاستردادات",
  "Unique Confirmed Buyers": "المشترين المؤكدين من غير تكرار",
  "confirmed sales transactions": "عمليات بيع مؤكدة",
  "Monthly Achievement": "الإنجاز الشهري",
  "Target Achievement": "تحقيق الهدف",
  "Target not defined": "الهدف مش محدد",
  "Target:": "الهدف:",
  "Not Defined": "مش محدد",
  "Sales achieved to date:": "المبيعات المحققة لحد دلوقتي:",
  "Expected to date:": "المتوقع لحد دلوقتي:",
  "Target window:": "فترة الهدف:",
  "Earned Commission:": "العمولة المستحقة:",
  "N/A — No Commission Policy": "غير متاح — مفيش سياسة عمولة",
  "(provisional until month closes)": "(مؤقت لحد ما الشهر يتقفل)",
  "Confirmed Sales Transactions": "عمليات البيع المؤكدة",
  "Booked / Registered in Period": "حجوزات / تسجيلات مكتملة في الفترة",
  "Current Operational Status": "الحالة التشغيلية الحالية",
  "Live snapshot · Cairo today": "الوضع الحالي · النهارده بتوقيت القاهرة",
  "New / Old Data Without Action": "بيانات جديدة / قديمة من غير إجراء",
  "No first contact recorded, including unassigned leads": "مفيش أول تواصل مسجل، وده يشمل العملاء غير المتوزعين",
  "Overdue Follow Ups": "متابعات متأخرة",
  "Follow ups due today: {0}": "متابعات ميعادها النهارده: {0}",
  "Registered — Waiting Payment": "التسجيل مكتمل — مستني الدفع",
  "Registered waiting {0}: {1}": "مسجلين ومستنيين {0}: {1}",
  "Payment Pending — Customers": "الدفع قيد المراجعة — العملاء",
  "payment requests": "طلبات دفع",
  "pending": "قيد المراجعة",
  "Payment pending {0}: {1}": "الدفع قيد المراجعة {0}: {1}",
  "Marketing → Reception approval": "التسويق ← موافقة الاستقبال",
  "Sales Team Performance": "أداء فريق المبيعات",
  "Selected Period": "الفترة المختارة",
  "Search team": "ابحث في الفريق",
  "Sort team": "ترتيب الفريق",
  "Highest sales": "أعلى مبيعات",
  "Highest collection": "أعلى تحصيل",
  "Most overdue": "أكتر متابعات متأخرة",
  "Sales Value": "قيمة المبيعات",
  "Cash Collected": "النقد المحصل",
  "Achievement": "الإنجاز",
  "Expected To Date": "المتوقع لحد دلوقتي",
  "Commission Rate": "نسبة العمولة",
  "Earned Commission": "العمولة المستحقة",
  "{0} confirmed sales: {1}": "{0} مبيعات مؤكدة: {1}",
  "Sales to date: {0}": "المبيعات لحد دلوقتي: {0}",
  "Not configured": "مش متظبط",
  "Provisional": "مؤقت",
  "Manager Attention": "ما يحتاج انتباه المدير",
  "Live operational alerts": "تنبيهات التشغيل الحالية",
  "Pipeline Overview": "نظرة عامة على مراحل البيع",
  "Live Snapshot": "الوضع الحالي",
  "Current status, independent of the selected period": "الحالة الحالية، بغض النظر عن الفترة المختارة",
  "Paid (Current)": "الدفع معتمد (حاليًا)",
  "Lead Origins": "مصادر العملاء",
  "Ads and manual creation are counted separately.": "الإعلانات والإضافة اليدوية بيتحسبوا كل واحد لوحده.",
  "Open lead list": "فتح قائمة العملاء",
  "Leads by Course": "العملاء حسب الكورس",
  "A lead with multiple interests appears in each matching course.": "العميل اللي مهتم بأكتر من كورس بيظهر في كل كورس مطابق.",
  "{0}: {1} leads": "{0}: {1} عملاء",
  "No course data in this scope.": "مفيش بيانات كورسات في النطاق ده.",
  "Key Conversion": "مؤشر التحويل الأساسي",
  "Performance in Selected Period": "الأداء في الفترة المختارة",
  "Demo completion: {0}%": "إتمام الديمو: {0}%",
  "Demo completion": "إتمام الديمو",
  "scheduled / sent leads": "عملاء متحدد لهم ميعاد / اتبعت لهم",
  "qualified leads": "عملاء مؤهلين",
  "Sales, collection and conversion use the selected period. Pipeline, attention, sources and courses are current snapshots. Target progress uses its labelled monthly window.": "المبيعات والتحصيل والتحويل حسب الفترة المختارة. مراحل البيع والتنبيهات والمصادر والكورسات حسب الوضع الحالي. تقدم الهدف حسب الفترة الشهرية الموضحة.",
  "Last updated:": "آخر تحديث:",
  "Just now": "دلوقتي حالًا",
  "Drilldown": "التفاصيل",
  "constituent": "ضمن الإجمالي",
  "Period:": "الفترة:",
  "Close drilldown": "قفل التفاصيل",
  "Selected period": "الفترة المختارة",
  "Previous period": "الفترة السابقة",
  "Details total:": "إجمالي التفاصيل:",
  "Loading details…": "جاري تحميل التفاصيل…",
  "Record {0}": "سجل {0}",
  "No constituent records": "مفيش سجلات ضمن الإجمالي",
  "The metric is currently zero for this scope.": "قيمة المؤشر حاليًا صفر في النطاق ده.",
  "Previous page": "الصفحة السابقة",
  "Page": "صفحة",
  "Next page": "الصفحة التالية",
  "Showing the first": "عرض أول",
  "operational rows. Narrow the filters to inspect the remaining records. Export Summary contains totals, not this list.": "صفوف تشغيلية. ضيق الفلاتر لمراجعة باقي السجلات. تصدير الملخص فيه الإجماليات، مش القائمة دي.",
  "Coaching Signals": "مؤشرات التوجيه",
  "Stable": "مستقر",
  "No coaching signals right now.": "مفيش مؤشرات محتاجة توجيه حاليًا.",
  "Behavior Summary": "ملخص السلوك",
  "Follow-ups done": "متابعات مكتملة",
  "New contacted": "عملاء جدد تم التواصل معاهم",
  "Urgent fixed": "عاجل تم حله",
  "Urgent left": "عاجل لسه مفتوح",
  "Logged today:": "المسجل النهارده:",
  "calls,": "مكالمات،",
  "WhatsApp actions,": "إجراءات واتساب،",
  "emails,": "إيميلات،",
  "notes.": "ملاحظات.",
  "Yday": "امبارح",
  "Week": "أسبوع",
  "{0} to {1}": "من {0} إلى {1}",
  "No actionable data found for this range.": "مفيش بيانات محتاجة إجراء في الفترة دي.",
  "{0} Details": "تفاصيل {0}",
  "Metric Details": "تفاصيل المؤشر",
  "Search by lead/task/course": "ابحث بالعميل / المهمة / الكورس",
  "No records for this metric and filter.": "مفيش سجلات للمؤشر والفلتر ده.",
  "Open Task": "فتح المهمة",
  "Speed & Contact Quality": "سرعة وجودة التواصل",
  "How quickly and effectively conversations start.": "قد إيه التواصل بيبدأ بسرعة وفعالية.",
  "Pipeline Movement": "حركة مراحل البيع",
  "Whether conversations are becoming business outcomes.": "هل التواصل بيتحول لنتائج فعلية.",
  "Follow-up Discipline": "الالتزام بالمتابعة",
  "Whether next actions are being created and finished.": "هل الخطوات الجاية بتتحدد وبتخلص.",
  "Leads Assigned": "العملاء المتوزعين",
  "Total leads assigned in selected period": "إجمالي العملاء المتوزعين في الفترة المختارة",
  "Open leads": "فتح العملاء",
  "Attempted Contacts": "محاولات التواصل",
  "Leads with attempted contact": "عملاء حصلت معاهم محاولة تواصل",
  "Open contacts": "فتح محاولات التواصل",
  "Follow-ups Completed": "متابعات مكتملة",
  "Tasks completed from queue/history": "مهام مكتملة من القائمة / السجل",
  "Open completed tasks": "فتح المهام المكتملة",
  "Registered or enrolled leads": "عملاء التسجيل بتاعهم مكتمل أو ملتحقين",
  "Open registrations": "فتح التسجيلات",
  "Payments / Revenue": "الدفعات / الإيرادات",
  "Revenue from first invoices": "إيرادات أول فواتير",
  "Open payments": "فتح الدفعات",
  "Open conversion leads": "فتح العملاء المتحولين",
  "Avg First Response Time": "متوسط وقت أول استجابة",
  "Minutes from assignment to first meaningful touch": "الدقايق من توزيع العميل لحد أول تواصل فعلي",
  "Open delayed leads": "فتح العملاء المتأخرين",
  "Work signals": "مؤشرات العمل",
  "Coaching Dashboard": "لوحة التوجيه",
  "Response speed, follow-up discipline, pipeline movement, and payment progress.": "سرعة الاستجابة، والالتزام بالمتابعة، وحركة مراحل البيع، وتقدم الدفع.",
  "Performance drilldowns are unavailable": "تفاصيل الأداء مش متاحة",
  "Try refreshing this page.": "جرب تحديث الصفحة.",
  "Today focus": "أولوية النهارده",
  "Today Focus": "أولوية النهارده",
  "No urgent sales signals in this window.": "مفيش مؤشرات مبيعات عاجلة في الفترة دي.",
  "Loading targets…": "جاري تحميل الأهداف…",
  "Tags": "الوسوم",
  "Filter by Tag": "فلتر بالوسم",
  "Filter by Course": "فلتر بالكورس",
  "Lead Source": "مصدر العميل",
  "Gross": "الإجمالي",
  "Leaderboard": "ترتيب المتصدرين",
  "Employees": "الموظفين",
  "Loading course plan…": "جاري تحميل خطة الكورسات…",
  "Set the sales amount and student price for each course. Students are calculated automatically; the company target is their total. Changing a course price also updates the value of inherited employee student allocations from this month.": "حدد مبلغ المبيعات وسعر الطالب لكل كورس. عدد الطلاب بيتحسب تلقائيًا، وهدف الشركة مجموعهم. تغيير سعر الكورس بيحدث كمان قيمة توزيعات الطلاب الموروثة للموظفين من الشهر ده.",
  "Inherited from": "موروث من",
  "Requested sales goal (EGP)": "هدف المبيعات المطلوب (جنيه)",
  "Price per student (EGP)": "السعر لكل طالب (جنيه)",
  "Students needed": "عدد الطلاب المطلوب",
  "Final course target": "هدف الكورس النهائي",
  "{0} sales goal": "هدف مبيعات {0}",
  "{0} student price": "سعر الطالب في {0}",
  "Add course": "إضافة كورس",
  "Add a course": "إضافة كورس",
  "Final company target:": "هدف الشركة النهائي:",
  "Each goal rounds up to whole students. Review this final amount before saving.": "كل هدف بيتقرب لأعلى لعدد طلاب صحيح. راجع المبلغ النهائي قبل الحفظ.",
  "Save course plan": "حفظ خطة الكورسات",
  "Loading assigned courses…": "جاري تحميل الكورسات المتعينة…",
  "Only this employee’s assigned courses appear. The server checks the course and company limits before saving.": "بيظهر بس الكورسات المتعينة للموظف ده. السيرفر بيراجع حدود الكورس والشركة قبل الحفظ.",
  "Removed course assignments will have their old targets cleared when you save:": "أهداف الكورسات اللي اتشالت من التعيين هتتمسح لما تحفظ:",
  "Assigned course": "الكورس المتعين",
  "Sales goal (EGP)": "هدف المبيعات (جنيه)",
  "Final target": "الهدف النهائي",
  "Available capacity": "السعة المتاحة",
  "per student": "لكل طالب",
  "{0} employee goal": "هدف الموظف لكورس {0}",
  "students ·": "طلاب ·",
  "No assigned courses in the company plan. Add the course plan and assign courses in Team first.": "مفيش كورسات متعينة ضمن خطة الشركة. ضيف خطة الكورسات وعيّن الكورسات من صفحة الفريق الأول.",
  "Final employee target:": "هدف الموظف النهائي:",
  "Save employee allocation": "حفظ توزيع الموظف",
  "Find an employee": "ابحث عن موظف",
  "Employee status": "حالة الموظف",
  "Allocation employee status": "حالة الموظف في التوزيع",
  "Vacation": "إجازة",
  "Former staff": "موظفين سابقين",
  "Previous employees": "الموظفين السابقين",
  "Next employees": "الموظفين التاليين",
  "Loading commission rules…": "جاري تحميل قواعد العمولة…",
  "Existing rules stay active. Changes start {0}.": "القواعد الحالية بتفضل شغالة. التغييرات بتبدأ {0}.",
  "First setup applies immediately this month.": "أول إعداد بيطبق فورًا في الشهر ده.",
  "Rules continue every month until changed.": "القواعد بتستمر كل شهر لحد ما تتغير.",
  "The achievement percentage chooses the rate; earned commission is that rate × actual cash collected. Example: Sales 100,000; collected 10,000; rate 10%; earned 1,000.": "نسبة تحقيق الهدف بتحدد نسبة العمولة؛ والعمولة المستحقة = النسبة دي × النقد المحصل فعليًا. مثال: مبيعات 100,000؛ تحصيل 10,000؛ نسبة 10%؛ عمولة مستحقة 1,000.",
  "Active rules:": "القواعد السارية:",
  "From achievement (%)": "من نسبة تحقيق (%)",
  "Commission on actual collection (%)": "العمولة على التحصيل الفعلي (%)",
  "Achievement threshold {0}": "حد تحقيق الهدف {0}",
  "Commission rate {0}": "نسبة العمولة {0}",
  "Remove rule {0}": "إزالة القاعدة {0}",
  "Add rule": "إضافة قاعدة",
  "Save commission rules": "حفظ قواعد العمولة",
  "Discard unsaved target changes?": "تجاهل تغييرات الأهداف اللي متحفظتش؟",
  "Target builder": "إعداد الأهداف",
  "Build targets": "إعداد الأهداف",
  "Plan month": "شهر الخطة",
  "One continuing plan. Editing a month creates a new plan from that month onward and preserves previous months.": "خطة مستمرة واحدة. تعديل شهر بيعمل خطة جديدة من الشهر ده وطالع، وبيحافظ على الشهور اللي قبله.",
  "Target setup sections": "أقسام إعداد الأهداف",
  "Team targets": "أهداف الفريق",
  "My target and earnings": "هدفي ومستحقاتي",
  "Sales targets & commission": "أهداف المبيعات والعمولة",
  "My target & commission": "هدفي والعمولة",
  "Target month": "شهر الهدف",
  "Build targets & commission rules": "إعداد الأهداف وقواعد العمولة",
  "Company sales target": "هدف مبيعات الشركة",
  "My sales target": "هدف مبيعاتي",
  "% achieved · Sum of the course sales targets.": "% محقق · مجموع أهداف مبيعات الكورسات.",
  "Full course sales value": "قيمة مبيعات الكورسات كاملة",
  "Full agreed invoice value credited this month, regardless of installment timing.": "قيمة الفاتورة المتفق عليها كاملة والمحسوبة في الشهر ده، بغض النظر عن مواعيد الأقساط.",
  "Actual cash collected": "النقد المحصل فعليًا",
  "Collected from this month’s sales": "تحصيل مبيعات الشهر",
  "Collected from previous months’ sales": "تحصيل مبيعات سابقة",
  "Total cash collected": "إجمالي التحصيل",
  "Sales this month": "مبيعات الشهر",
  "Eligible payments actually received this month, including installments.": "الدفعات المؤهلة المستلمة فعلًا في الشهر ده، بما فيها الأقساط.",
  "Existing allocations exceed the company plan by": "التوزيعات الحالية بتتجاوز خطة الشركة بمقدار",
  ". Review the course plan and employee allocations; new saves cannot increase an over-allocation.": ". راجع خطة الكورسات وتوزيعات الموظفين؛ الحفظ الجديد ما ينفعش يزود التجاوز.",
  "Employee allocations": "توزيعات الموظفين",
  "My results": "نتائجي",
  "unallocated": "غير موزع",
  "Sales target": "هدف المبيعات",
  "Full course value sold": "قيمة الكورسات المباعة كاملة",
  "Target achieved": "نسبة تحقيق الهدف",
  "Earned commission": "العمولة المستحقة",
  "N/A — No Target": "غير متاح — مفيش هدف",
  "% of actual collected payments": "% من الدفعات المحصلة فعليًا",
  "No employees found for this month.": "مفيش موظفين للشهر ده.",
  "Sales-target achievement uses full sales value. Earned commission applies to actual cash collected under the applicable policy.": "تحقيق هدف المبيعات بيتحسب بقيمة المبيعات كاملة. العمولة المستحقة بتتطبق على النقد المحصل فعليًا حسب السياسة السارية.",
  "Loading sales team...": "جاري تحميل فريق المبيعات...",
  "Search salesperson...": "ابحث عن مندوب مبيعات...",
  "No matching salespeople": "مفيش مندوبي مبيعات مطابقين",
  "Company Monthly Target": "هدف الشركة الشهري",
  "Active Allocations": "توزيعات الموظفين النشطين",
  "Vacation Allocations": "توزيعات الموظفين في إجازة",
  "Left Allocations": "توزيعات الموظفين اللي سابوا الشركة",
  "Remaining To Distribute": "المتبقي للتوزيع",
  "Overallocated": "التوزيع متجاوز الهدف",
  "Manager bonus": "مكافأة المدير",
  "Remove course line?": "إزالة بند الكورس؟",
  "Remove assignment line?": "إزالة بند التوزيع؟",
  "Company target change request submitted for Upper Management approval": "تم تقديم طلب تغيير هدف الشركة لموافقة الإدارة العليا",
  "Company target saved successfully": "تم حفظ هدف الشركة",
  "Failed to save company target": "تعذر حفظ هدف الشركة",
  "Company target change approved": "تمت الموافقة على تغيير هدف الشركة",
  "Company target change rejected": "تم رفض تغيير هدف الشركة",
  "Failed to review company target change request": "تعذر مراجعة طلب تغيير هدف الشركة",
  "Clear employee allocation?": "مسح توزيع الموظف؟",
  "Allocation cleared for the selected month and following inherited months": "تم مسح التوزيع للشهر المختار والشهور التالية اللي ورثته",
  "Assignment updated successfully": "تم تحديث التعيين",
  "Students assigned successfully": "تم توزيع الطلاب",
  "Failed to save target": "تعذر حفظ الهدف",
  "Competition created successfully": "تم إنشاء المسابقة",
  "Failed to create competition": "تعذر إنشاء المسابقة",
  "Award top performer?": "منح الجائزة لصاحب أعلى أداء؟",
  "{0} has been awarded the competition prize": "تم منح جائزة المسابقة لـ {0}",
  "Failed to award top performer": "تعذر منح الجائزة لصاحب أعلى أداء",
  "Commission rules saved. Effective {0}.": "تم حفظ قواعد العمولة. سارية من {0}.",
  "Failed to update tiers": "تعذر تحديث الشرائح",
  "Commission tiers locked for this month": "شرائح العمولة مقفولة للشهر ده",
  "Failed to lock tiers": "تعذر قفل الشرائح",
  "Bronze": "برونزي",
  "Silver": "فضي",
  "Gold": "ذهبي",
  "Platinum": "بلاتيني",
  "Diamond": "ماسي",
  "Manager commission settings updated successfully": "تم تحديث إعدادات عمولة المدير",
  "Failed to update manager commission": "تعذر تحديث عمولة المدير",
  "Failed to update policy review item": "تعذر تحديث بند مراجعة السياسة",
  "First contact missing": "أول تواصل مش مسجل",
  "WhatsApp follow-up needed": "محتاج متابعة واتساب",
  "Current Target": "الهدف الحالي",
  "Competitions": "المسابقات",
  "Policy Review": "مراجعة السياسة",
  "Auto Money Target": "الهدف المالي التلقائي",
  "Collected: {0}": "المحصل: {0}",
  "{0}% of target achieved!": "تم تحقيق {0}% من الهدف!",
  "Manage": "إدارة",
  "Edit Assignment": "تعديل التعيين",
  "Assignment actions": "إجراءات التعيين",
  "Competition": "المسابقة",
  "Winning Metric": "معيار الفوز",
  "Prize": "الجائزة",
  "Rank": "الترتيب",
  "Winner!": "الفائز!",
  "Monthly Target Builder": "إعداد الأهداف الشهرية",
  "Build company targets, assign students, review competitions, policy items, and closed-month history.": "حدد أهداف الشركة، ووزع الطلاب، وراجع المسابقات وبنود السياسة وسجل الشهور المقفولة.",
  "Build / Edit Company Target": "إعداد / تعديل هدف الشركة",
  "View Breakdown": "عرض التفاصيل",
  "View / Edit Breakdown": "عرض / تعديل التفاصيل",
  "Assign Students": "توزيع الطلاب",
  "Sales targets workspace": "مساحة أهداف المبيعات",
  "No pending company target approvals": "مفيش موافقات معلقة لأهداف الشركة",
  "Sales manager edits to the active company target will appear here for approval.": "تعديلات مدير المبيعات على هدف الشركة الحالي هتظهر هنا للموافقة.",
  "Requested by": "الطلب بواسطة",
  "course line": "بند كورس",
  "Submitted": "اتقدم",
  "Requested Target": "الهدف المطلوب",
  "Monthly Target": "الهدف الشهري",
  "Bonus:": "المكافأة:",
  "Weekly Reward": "المكافأة الأسبوعية",
  "No weekly tier yet": "لسه مفيش شريحة أسبوعية",
  "Booking Reward": "مكافأة الحجز",
  "{0}% booking / {1}% response": "{0}% حجز / {1}% استجابة",
  "No booking reward yet": "لسه مفيش مكافأة حجز",
  "Social / B2B": "التواصل الاجتماعي / مبيعات الشركات",
  "Social:": "التواصل الاجتماعي:",
  "clients": "عملاء",
  "Compliance Alerts": "تنبيهات الالتزام",
  "Two-hour:": "خلال ساعتين:",
  "/ WhatsApp:": "/ واتساب:",
  "Booking reward is blocked until response rate reaches 70%.": "مكافأة الحجز متوقفة لحد ما نسبة الاستجابة توصل 70%.",
  "Company monthly target": "هدف الشركة الشهري",
  "Achieved So Far": "المحقق لحد دلوقتي",
  "Edit Tiers": "تعديل الشرائح",
  "Lock Tiers": "قفل الشرائح",
  "Salesperson tiers": "شرائح مندوبي المبيعات",
  "{0} active rules": "{0} قواعد سارية",
  "No rules configured yet": "لسه مفيش قواعد متظبطة",
  "Locked": "مقفول",
  "Editable": "قابل للتعديل",
  "Tier {0}": "الشريحة {0}",
  "No salesperson tiers": "مفيش شرائح لمندوبي المبيعات",
  "Add commission tiers so bonuses calculate automatically.": "ضيف شرائح عمولة عشان المكافآت تتحسب تلقائيًا.",
  "Manager rule": "قاعدة المدير",
  "Click the rule to edit": "اضغط على القاعدة لتعديلها",
  "Controlled by GM permissions": "حسب صلاحيات المدير العام",
  "Tiered: {0}": "حسب الشرائح: {0}",
  "Flat rate: {0}%": "نسبة ثابتة: {0}%",
  "Tiered": "حسب الشرائح",
  "Flat": "ثابت",
  "Tiered manager commission": "عمولة المدير حسب الشرائح",
  "tiers": "شرائح",
  "Flat manager rate": "نسبة المدير الثابتة",
  "Editable now": "متاح للتعديل دلوقتي",
  "GM only": "المدير العام بس",
  "Manager action": "إجراء المدير",
  "The system creates review items automatically. Approve, waive, or adjust the amount once; closed items stay out of the queue.": "السيستم بيعمل بنود المراجعة تلقائيًا. وافق أو اعفِ أو عدل المبلغ مرة واحدة؛ البنود المقفولة مش بترجع للقائمة.",
  "Bonuses": "المكافآت",
  "Penalties": "الجزاءات",
  "1 item waiting": "بند واحد مستني المراجعة",
  "{0} items waiting": "{0} بنود مستنية المراجعة",
  "Bonus items": "بنود المكافآت",
  "Penalty items": "بنود الجزاءات",
  "Total bonus": "إجمالي المكافآت",
  "Total penalty": "إجمالي الجزاءات",
  "Open folder": "فتح الملف",
  "No policy decisions waiting": "مفيش قرارات سياسة مستنية المراجعة",
  "Bonuses and penalties that are already approved or waived will not show again.": "المكافآت والجزاءات اللي اتوافق عليها أو اتعمل لها إعفاء مش هتظهر تاني.",
  "Policy folder": "ملف السياسة",
  "Waiting items": "البنود المستنية",
  "Review item": "مراجعة البند",
  "Active Salespeople": "مندوبي المبيعات النشطين",
  "Left Employees Hidden": "الموظفين اللي سابوا الشركة مخفيين",
  "students": "طلاب",
  "price": "السعر",
  "No course assignment details available.": "مفيش تفاصيل متاحة لتعيين الكورسات.",
  "Create Competition": "إنشاء مسابقة",
  "Total Prizes": "إجمالي الجوائز",
  "Course:": "الكورس:",
  "Prize:": "الجائزة:",
  "Previous closed months only": "الشهور السابقة المقفولة بس",
  "Assigned Target": "الهدف المتعين",
  "Overall Progress": "التقدم الإجمالي",
  "Competitions count": "عدد المسابقات",
  "No closed target months available yet.": "لسه مفيش شهور أهداف مقفولة.",
  "Total from commission tiers": "الإجمالي من شرائح العمولة",
  "N/A — Incomplete commission policies": "غير متاح — سياسات العمولة ناقصة",
  "Manager:": "المدير:",
  "Achieved (Gross)": "المحقق (الإجمالي)",
  "Tier / Rate": "الشريحة / النسبة",
  "No calculated bonuses yet for this period": "لسه مفيش مكافآت محسوبة للفترة دي",
  "Bonuses are calculated based on commission tiers when salespeople meet their targets": "المكافآت بتتحسب حسب شرائح العمولة لما مندوبي المبيعات يحققوا أهدافهم",
  "Sales Manager Bonus": "مكافأة مدير المبيعات",
  "Based on Total Gross": "حسب إجمالي المبيعات",
  "Overall Progress / Rate": "التقدم الإجمالي / النسبة",
  "% Progress": "نسبة التقدم %",
  "% Commission": "نسبة العمولة %",
  "Tier": "الشريحة",
  "Edit Company Target": "تعديل هدف الشركة",
  "Build Company Target": "إعداد هدف الشركة",
  "Target Month": "شهر الهدف",
  "Please select a month": "اختار شهر",
  "Company course/program lines": "بنود كورسات / برامج الشركة",
  "Add Another Course Line": "إضافة بند كورس تاني",
  "Expected Individuals": "عدد الأفراد المتوقع",
  "Enter expected count": "اكتب العدد المتوقع",
  "Expected individuals must be greater than zero": "عدد الأفراد المتوقع لازم يكون أكبر من صفر",
  "Course Price": "سعر الكورس",
  "Enter course price": "اكتب سعر الكورس",
  "Course price must be greater than zero": "سعر الكورس لازم يكون أكبر من صفر",
  "Subtotal": "الإجمالي الفرعي",
  "Remove Line": "إزالة البند",
  "Final Company Monthly Target": "هدف الشركة الشهري النهائي",
  "Submit Change Request": "تقديم طلب تغيير",
  "Save Company Target": "حفظ هدف الشركة",
  "Build Company Target first": "حدد هدف الشركة الأول",
  "Employee assignments use the approved company course prices for this month.": "توزيعات الموظفين بتستخدم أسعار كورسات الشركة المعتمدة للشهر ده.",
  "Please select a salesperson": "اختار مندوب مبيعات",
  "Select salesperson": "اختار مندوب المبيعات",
  "Uses the page month and its approved prices. Close this form and change the page month to choose another period.": "بيستخدم الشهر المختار في الصفحة وأسعاره المعتمدة. اقفل النموذج وغيّر شهر الصفحة لو عايز فترة تانية.",
  "Student counts by course/program": "عدد الطلاب حسب الكورس / البرنامج",
  "Add Assignment Line": "إضافة بند توزيع",
  "Assigned Students": "الطلاب المتوزعين",
  "Enter count": "اكتب العدد",
  "Assigned students must be greater than zero": "عدد الطلاب المتوزعين لازم يكون أكبر من صفر",
  "Approved Course Price:": "سعر الكورس المعتمد:",
  "No price": "مفيش سعر",
  "Remove Assignment Line": "إزالة بند التوزيع",
  "Available To Assign": "المتاح للتوزيع",
  "Clear allocation": "مسح التوزيع",
  "Please fill in all required fields": "كمل كل الحقول المطلوبة",
  "Competition Name": "اسم المسابقة",
  "Please enter competition name": "اكتب اسم المسابقة",
  "e.g., Top performer challenge": "مثال: تحدي أعلى أداء",
  "Competition Scope": "نطاق المسابقة",
  "Please select competition scope": "اختار نطاق المسابقة",
  "Select scope": "اختار النطاق",
  "Custom Date Range": "فترة مخصصة",
  "Manager-defined start and end dates": "تواريخ البداية والنهاية اللي حددها المدير",
  "Sales Team": "فريق المبيعات",
  "All eligible active salespeople": "كل مندوبي المبيعات النشطين المؤهلين",
  "Please select a start date": "اختار تاريخ البداية",
  "Please select an end date": "اختار تاريخ النهاية",
  "Select winning metric": "اختار معيار الفوز",
  "Rank by gross course value": "ترتيب حسب إجمالي قيمة الكورسات",
  "Enrollments Count": "عدد الالتحاقات",
  "Paid enrollments only": "الالتحاقات بدفع معتمد بس",
  "Target Progress %": "نسبة تقدم الهدف %",
  "Rank by target achievement percentage": "ترتيب حسب نسبة تحقيق الهدف",
  "Fast First Responses": "سرعة أول استجابة",
  "First direct response speed": "سرعة أول رد مباشر",
  "Course Bookings": "حجوزات الكورسات",
  "Paid bookings for one course": "حجوزات بدفع معتمد لكورس واحد",
  "Meaningful Follow-ups": "متابعات فعلية",
  "Distinct direct follow-up days": "أيام المتابعة المباشرة من غير تكرار",
  "Please select a course": "اختار كورس",
  "Target to Win": "الهدف المطلوب للفوز",
  "Please enter target value": "اكتب قيمة الهدف",
  "Prize Amount (EGP)": "قيمة الجائزة (جنيه)",
  "Please enter prize amount": "اكتب قيمة الجائزة",
  "Prize Description": "وصف الجائزة",
  "e.g., Bonus + Certificate": "مثال: مكافأة + شهادة",
  "Rules": "القواعد",
  "Please enter competition rules": "اكتب قواعد المسابقة",
  "Enter competition rules...": "اكتب قواعد المسابقة...",
  "Commission tiers define the bonus percentage salespeople earn based on their target achievement.": "شرائح العمولة بتحدد نسبة المكافأة اللي مندوب المبيعات بيستحقها حسب تحقيق الهدف.",
  "Note: If the month has already started, changes will only apply from next month.": "ملاحظة: لو الشهر بدأ، التغييرات هتتطبق من الشهر الجاي بس.",
  "Full sales achievement selects the rate; earned commission uses actual cash collected. Existing policy changes apply next month; first setup applies this month.": "تحقيق المبيعات بالقيمة الكاملة بيحدد النسبة؛ والعمولة المستحقة بتتحسب على النقد المحصل فعليًا. تغييرات السياسة الحالية بتطبق الشهر الجاي؛ وأول إعداد بيطبق الشهر ده.",
  "Min %": "الحد الأدنى %",
  "Max %": "الحد الأقصى %",
  "Rate %": "النسبة %",
  "e.g., Bronze Tier": "مثال: الشريحة البرونزية",
  "Add Tier": "إضافة شريحة",
  "Save Commission Tiers": "حفظ شرائح العمولة",
  "Manager commission is based on total team gross income vs total team targets.": "عمولة المدير حسب إجمالي دخل الفريق قبل الخصومات مقارنة بإجمالي أهداف الفريق.",
  "You can use a flat rate OR tiered rates based on overall progress. Only the General Manager can modify these settings.": "تقدر تستخدم نسبة ثابتة أو شرائح حسب التقدم الإجمالي. المدير العام بس يقدر يعدل الإعدادات دي.",
  "Enable to use different rates based on overall progress percentage": "فعّل عشان تستخدم نسب مختلفة حسب نسبة التقدم الإجمالي",
  "Use Tiered Commission (like salesperson tiers)": "استخدام عمولة بالشرائح (زي شرائح مندوبي المبيعات)",
  "Flat Commission Rate (%)": "نسبة العمولة الثابتة (%)",
  "Please enter commission rate": "اكتب نسبة العمولة",
  "Manager receives commission based on team's overall progress (Total Gross / Total Targets):": "المدير بياخد عمولة حسب تقدم الفريق الإجمالي (إجمالي الدخل قبل الخصومات / إجمالي الأهداف):",
  "e.g., Gold": "مثال: ذهبي",
  "Add Manager Tier": "إضافة شريحة للمدير",
  "Notes (optional)": "ملاحظات (اختياري)",
  "Save Manager Commission Settings": "حفظ إعدادات عمولة المدير",
  "{0} History": "سجل {0}",
  "Target History": "سجل الأهداف",
  "Employee Sales & Competition Bonuses": "مكافآت مبيعات الموظفين والمسابقات",
  "Achieved / Sold": "المحقق / المباع",
  "Competition Bonus": "مكافأة المسابقة",
  "Competitions History": "سجل المسابقات",
  "Winner": "الفائز",
  "Loading competition details...": "جاري تحميل تفاصيل المسابقة...",
  "Winner: {0}": "الفائز: {0}",
  "Awarded performer": "الموظف الحاصل على الجائزة",
  "Award top performer": "منح الجائزة لصاحب أعلى أداء",
  "Competition not found": "المسابقة مش موجودة",
  "Company Target Breakdown": "تفاصيل هدف الشركة",
  "Assigned Money Target": "الهدف المالي المتعين",
  "Real Sales": "المبيعات الفعلية",
  "Pending Sales": "المبيعات المعلقة",
  "Total Gross": "الإجمالي قبل الخصومات",
  "Salesman": "مندوب المبيعات",
  "Ad": "الإعلان",
  "Ad Set": "مجموعة الإعلانات",
  "Total Leads": "إجمالي العملاء",
  "Leads This Month": "عملاء الشهر ده",
  "Conversions": "التحويلات",
  "Rev (Real)": "الإيرادات (الفعلية)",
  "Gross (Real)": "الإجمالي (الفعلي)",
  "Avg Rev": "متوسط الإيراد",
  "In Groups": "داخل مجموعات",
  "No Group": "من غير مجموعة",
  "Pending Enrollment": "الالتحاق قيد الانتظار",
  "Could not update sales figures.": "تعذر تحديث أرقام المبيعات.",
  "Showing the last successfully loaded figures for the current filters. They may be out of date.": "بنعرض آخر أرقام اتحملت بنجاح للفلاتر الحالية. ممكن تكون قديمة.",
  "Retry refresh": "إعادة محاولة التحديث",
  "Could not load sales overview": "تعذر تحميل نظرة عامة على المبيعات",
  "Sales figures are unavailable for the current filters. Try again to load them.": "أرقام المبيعات مش متاحة للفلاتر الحالية. جرب تحميلها تاني.",
  "Date Range": "الفترة",
  "Dashboard starts month-to-date by default. Clear the dates if you need the full history view.": "اللوحة بتبدأ افتراضيًا من أول الشهر للنهارده. امسح التواريخ لو محتاج السجل كامل.",
  "Choose a valid From and To date before applying.": "اختار تاريخ بداية ونهاية صالحين قبل التطبيق.",
  "Select Salesman": "اختار مندوب مبيعات",
  "Course & Source": "الكورس والمصدر",
  "Campaign Details": "تفاصيل الحملة",
  "No Campaign IDs": "مفيش أرقام حملات",
  "Campaign Name": "اسم الحملة",
  "No Campaign Names": "مفيش أسماء حملات",
  "Ad Set Name": "اسم مجموعة الإعلانات",
  "No Ad Set Names": "مفيش أسماء مجموعات إعلانات",
  "Ad Name": "اسم الإعلان",
  "No Ad Names": "مفيش أسماء إعلانات",
  "Reset All Filters": "إعادة ضبط كل الفلاتر",
  "Apply Filters": "تطبيق الفلاتر",
  "Sales Manager Dashboard": "لوحة مدير المبيعات",
  "Loading analytics...": "جاري تحميل التحليلات...",
  "Date range:": "الفترة:",
  "Overview": "نظرة عامة",
  "Lost Rate": "نسبة العملاء المفقودين",
  "Avg Attempts to Convert": "متوسط المحاولات لحد التحويل",
  "Reasons (by tag):": "الأسباب (حسب الوسم):",
  "No lost leads": "مفيش عملاء مفقودين",
  "No call data": "مفيش بيانات مكالمات",
  "Revenue & Courses": "الإيرادات والكورسات",
  "No revenue data": "مفيش بيانات إيرادات",
  "No course data": "مفيش بيانات كورسات",
  "Sources & Priority": "المصادر والأولوية",
  "Conv %": "نسبة التحويل %",
  "No source data": "مفيش بيانات مصادر",
  "leads": "عملاء",
  "Conv Rate": "نسبة التحويل",
  "No priority data": "مفيش بيانات أولوية",
  "Select Status": "اختار الحالة",
  "Exact Pipeline Status": "الحالة الدقيقة في مراحل البيع",
  "Filter by Source": "فلتر بالمصدر",
  "Select a status to view leads": "اختار حالة لعرض العملاء",
  "Last Outcome": "آخر نتيجة",
  "No {0} leads found": "مفيش عملاء بحالة {0}",
  "No activity data": "مفيش بيانات نشاط",
  "Failed to load data": "تعذر تحميل البيانات",
  "Lead Activity by Rep": "نشاط العملاء حسب المندوب",
  "Distinct leads per rep with logged activity in this period": "العملاء من غير تكرار لكل مندوب وعليهم نشاط مسجل في الفترة دي",
  "Team Conversions": "تحويلات الفريق",
  "Sum of rep conversion counts in this period": "مجموع تحويلات المندوبين في الفترة دي",
  "Response Discipline": "الالتزام بالاستجابة",
  "Revenue Moved": "الإيرادات المحققة",
  "First invoice revenue attributed to sales": "إيرادات أول فاتورة المنسوبة للمبيعات",
  "Logged Activities": "الأنشطة المسجلة",
  "Team history events recorded in the selected period.": "أحداث سجل الفريق المسجلة في الفترة المختارة.",
  "Most Conversions": "أعلى تحويلات",
  "Slowest Response": "أبطأ استجابة",
  "Total leads assigned to this salesman": "إجمالي العملاء المتوزعين على المندوب ده",
  "Distinct leads with any logged activity in the selected period": "العملاء من غير تكرار وعليهم أي نشاط مسجل في الفترة المختارة",
  "Total follow-up actions completed": "إجمالي إجراءات المتابعة المكتملة",
  "Leads converted to enrolled students": "عملاء اتحولوا لطلاب ملتحقين",
  "Conversion events in the period divided by leads created in the period; these may be different lead cohorts": "أحداث التحويل في الفترة مقسومة على العملاء اللي اتسجلوا في الفترة؛ وممكن يكونوا مجموعات عملاء مختلفة",
  "Conv / New": "التحويلات / الجدد",
  "Average time to first contact": "متوسط الوقت لأول تواصل",
  "Avg Response": "متوسط الاستجابة",
  "Total revenue from converted students": "إجمالي الإيرادات من الطلاب المتحولين",
  "Revenue discipline": "الالتزام بالإيرادات",
  "Sales Performance": "أداء المبيعات",
  "Sales Performance Dashboard": "لوحة أداء المبيعات",
  "Compare team output, response behavior, conversion movement, and revenue in one operating view.": "قارن نتائج الفريق وسلوك الاستجابة وحركة التحويل والإيرادات في لوحة تشغيل واحدة.",
  "See what to fix now, what moved today, and where your sales effort is turning into money.": "شوف إيه محتاج يتصلح دلوقتي، وإيه اتغير النهارده، ومجهود المبيعات بيتحول لفلوس فين.",
  "Failed to load performance data: {0}": "تعذر تحميل بيانات الأداء: {0}",
  "Performance data is unavailable right now.": "بيانات الأداء مش متاحة دلوقتي.",
  "Business results and rewards": "نتائج الأعمال والمكافآت",
  "Targets, competitions, and enrolled payment progress": "الأهداف والمسابقات وتقدم دفعات الطلاب الملتحقين",
  "Bonus if Achieved": "المكافأة عند تحقيق الهدف",
  "No target assigned for this month yet.": "لسه مفيش هدف متعين للشهر ده.",
  "Weekly Competition": "المسابقة الأسبوعية",
  "Your Rank": "ترتيبك",
  "Your Score": "نتيجتك",
  "No active competition this week": "مفيش مسابقة شغالة الأسبوع ده",
  "Recent:": "الأحدث:",
  "Upcoming:": "القادم:",
  "LEAD": "العميل",
  "COURSE": "الكورس",
  "PAID": "المدفوع",
  "TOTAL": "الإجمالي",
  "REMAINING": "المتبقي",
  "PROGRESS": "التقدم",
  "Manager command": "إدارة المدير",
  "Team Performance Center": "مركز أداء الفريق",
  "Coach response discipline, protect open pipeline, and spot where revenue is actually moving.": "وجّه الالتزام بالاستجابة، وتابع فرص البيع المفتوحة، وحدد الإيرادات بتتحقق فين.",
  "{0} sales reps": "{0} مندوبي مبيعات",
  "{0} leads": "{0} عملاء",
  "{0} conversions": "{0} تحويلات",
  "Team operating signals": "مؤشرات تشغيل الفريق",
  "Manager coaching focus": "أولويات توجيه الفريق للمدير",
  "Coaching focus": "أولويات التوجيه",
  "What needs manager attention now": "إيه محتاج انتباه المدير دلوقتي",
  "Performance date filters": "فلاتر تاريخ الأداء",
  "Start date": "تاريخ البداية",
  "End date": "تاريخ النهاية",
  "Assign owner now": "عيّن مسؤول دلوقتي",
  "Active leads without an owner are the fastest way to lose demand.": "العملاء النشطين من غير مسؤول أسرع سبب لضياع اهتمام العملاء.",
  "Clear overdue follow-ups": "خلص المتابعات المتأخرة",
  "Coach activity gaps": "وجّه الفريق لسد نقص النشاط",
  "Open leads with no recent contact need a manager decision before they go cold.": "العملاء المفتوحين من غير تواصل حديث محتاجين قرار من المدير قبل ما يفقدوا الاهتمام.",
  "Rebalance workload": "وازن توزيع الشغل",
  "Protect revenue path": "تابع خطوات الوصول للإيراد",
  "Proposal, negotiation, and registered leads need close-out attention.": "العملاء في العرض والتفاوض واللي كملوا التسجيل محتاجين متابعة لإتمام البيع.",
  "New Leads Not Contacted": "عملاء جدد من غير تواصل",
  "Successful Contacts": "تواصل ناجح",
  "Follow-ups Created": "متابعات اتعملت",
  "Open follow-ups": "فتح المتابعات",
  "Overdue Tasks": "مهام متأخرة",
  "Open tasks": "فتح المهام",
  "Hot Leads Without Next Action": "عملاء مهتمين جدًا من غير خطوة جاية",
  "Proposals Sent": "عروض اتبعتت",
  "Open proposals": "فتح العروض",
  "Negotiations": "مفاوضات",
  "Contact Rate": "نسبة التواصل",
  "New leads still waiting first contact": "عملاء جدد لسه مستنيين أول تواصل",
  "Leads progressed after contact": "عملاء تقدموا بعد التواصل",
  "Follow-up reminders created": "تذكيرات متابعة اتعملت",
  "Tasks overdue now": "مهام متأخرة حاليًا",
  "Hot leads missing next action": "عملاء مهتمين جدًا ناقصهم خطوة جاية",
  "Leads in proposal stages": "عملاء في مراحل العرض",
  "Leads in negotiation stage": "عملاء في مرحلة التفاوض",
  "New leads without first contact": "عملاء جدد من غير أول تواصل",
  "Follow-ups need immediate action": "متابعات محتاجة إجراء فورًا",
  "Hot leads require next action": "عملاء مهتمين جدًا محتاجين خطوة جاية",
  "First response time target": "الوقت المستهدف لأول استجابة",
  "Call clicked from metric details": "تم الضغط على الاتصال من تفاصيل المؤشر",
  "WhatsApp opened from metric details": "تم فتح واتساب من تفاصيل المؤشر"
};

export const targetsEnglishTranslations: Record<string, string> = {
  "تعيين الكورسات وتوجيه العملاء": "Course assignment and lead routing",
  "عيّن كورسات محددة لكل مندوب مبيعات وتحكم في استقبال العملاء حسب اهتمام الكورس وتوفر الموظف.": "Assign specific courses to each salesperson and control lead routing by course interest and staff availability."
};
